import './bdcatering/style';
import FormStructure from './bdcatering/form_structure';

export default FormStructure;